import { render, staticRenderFns } from "./PatentAnnualFeeReminder.vue?vue&type=template&id=363882d0&"
import script from "./PatentAnnualFeeReminder.vue?vue&type=script&lang=js&"
export * from "./PatentAnnualFeeReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports